import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'  // ← Tailwind here
import App from './App'
import reportWebVitals from './reportWebVitals'

import { AuthProvider } from './context/AuthContext'
import { NotificationProvider } from './context/NotificationContext'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <AuthProvider>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </AuthProvider>
  </React.StrictMode>
)

// Optional: performance monitoring
reportWebVitals()